import React, { useEffect, useRef, useState } from "react";
import DataTable from "../_components/datatable/DataTable";
import { useNavigate } from "react-router-dom";
import { postGetAllQuestions, postUpSertQuestion } from "../../core/api/Api";

const Questions = () => {
  const mounted = useRef(true);
  let navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const columns = [
    { field: "name", headerName: "Name" },
    { field: "description", headerName: "Description" },
    {
      field: "question_category",
      headerName: "Question Category",
      renderCell: (params) => params?.value?.name ?? "",
    },
    {
      field: "category_length_type",
      headerName: "Question Length Type",
      renderCell: (params) => params?.value?.name ?? "",
    },
    {
      field: "category_based_type",
      headerName: "Category Based Type",
      renderCell: (params) => params?.value?.name ?? "",
    },
  ];

  const getData = (data) => {
    setLoading(true);
    postGetAllQuestions(data)
      .then((res) => {
        setLoading(false);
        if (mounted.current && res?.data?.success) {
          const data = res.data.success;
          setData(data);
        }
      })
      .catch((e) => {
        if (mounted.current) setLoading(false);
      });
  };

  const onDeleteDataTableRows = (data) => {
    setLoading(true);
    postUpSertQuestion(data)
      .then((res) => {
        setLoading(false);
        if (mounted.current && res?.data?.success) {
          const data = res.data.success;
          setData(data);
        }
      })
      .catch((e) => {
        if (mounted.current) setLoading(false);
      });
  };

  const onRowClick = (e) => {
    navigate("/question-details/" + e.id);
  };

  const onCreateButtonClick = () => {
    navigate("/question-details/create");
  };

  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);

  return (
    <DataTable
      columns={columns}
      data={data}
      loading={loading}
      onPageChangeProp={getData}
      onRowClick={onRowClick}
      onCreateButtonClick={onCreateButtonClick}
      onDeleteDataTableRows={onDeleteDataTableRows}
    />
  );
};

export default Questions;
